export const CourseSectionArtwork = ({ art, className = '' }) => <figure className={`course-section-art ${className}`}>
  <img src={art.src} alt={art.alt} width={art.width} height={art.height} loading="lazy" decoding="async" />
</figure>;
